module.exports = __webpack_public_path__ + "07b2b25254da11a808aed5789530d9e5.png";